<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + ' cond. oficina venta'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarCondOficinaVenta">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoCondOficinaVenta()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nueva condición
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <ag-grid-angular #agGridBonificadores (gridReady)="onGridReady($event)" class="ag-theme-alpine"
    [columnDefs]="columnDefsCondOficinaVenta" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
    id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
    [pagination]="true" [rowData]="rowDataCondOficinaVenta" *ngIf="!verFormularioAgregarCondOficinaVenta">
  </ag-grid-angular>
  <app-promo-oficina-form
    [idPromo]="idPromo"
    [idOficinas]="idOficinas"
    (back)="back()"
    (create)="guardarCondOficinaVenta($event)"
    *ngIf="verFormularioAgregarCondOficinaVenta"></app-promo-oficina-form>
</ng-template>
